exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.productImageArea {\n  position: relative;\n  background-size: cover;\n  background-position: center;\n  height: 180px;\n}\n.productImageArea:before {\n    content: '';\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    background-image: linear-gradient(rgba(0, 0, 0, 0.2), black);\n    opacity: .4;\n    z-index: 1;\n}\n.productImageArea * {\n    position: relative;\n    z-index: 2;\n}\n.productImageArea .checkAvailability {\n    opacity: 0;\n    position: absolute;\n    bottom: 10px;\n    width: 90%;\n    left: 5%;\n    transition: all 200ms ease-in-out;\n}\n.productImageArea:hover .checkAvailability {\n  opacity: 1;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"id":"data-v-08867137","scoped":false,"hasInlineConfig":false}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/reservations/NewReservation/Search/ProductList.vue
// module id = 2755
// module chunks = 0